<template>

  <div class="container">

    <div style="flex: 1;"></div>
    <img class="guide_img" src="@/assets/close_guide.png">
    <div class="title">通过对本机拨号关闭服务</div>
    <div class="sub_title">使用号码{{ num }}，关闭功能后电话助理将无法为你代接电话</div>

    <div style="flex: 1.5;"></div>
    <div class="close_button" @click="closeService">拨号关闭功能</div>
    <div class="help_layout" @click="help">
      <div class="help">设置不成功</div>
      <img class="help_arch" src="@/assets/arrow2.png">
    </div>
  </div>

</template>

<script>

import app from '@/AppData'
import util from '@/utils/util'
import {SERVICE_SWITCH} from '@/utils/const'
import lubanapi from '@/lubanapi'
import jsbridge from '@/jsbridge'

export default {
  name: 'CloseAiPage',
  data () {
    return {
      num: app.getData().userSetting.phoneNum
    }
  },

  methods: {
    closeService () {
      // 直接拨号
      // window.location.href = util.formatTelUrl('##004#');
      jsbridge.setAiRedirectCall('##004#').then(res => {
        // 记录状态
        app.putLocalStorage(SERVICE_SWITCH.NAME, SERVICE_SWITCH.STATE_CLOSE)
        lubanapi.reportseer('AICall_Close_Service_Dial_Button_Click')
      })
    },

    help () {
      util.openHelpWeb()
    }
  },

  mounted () {
    lubanapi.reportseer('AICall_Close_Service_Dial_Page_Shown')
  }
}
</script>

<style scoped>

.container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
}

.guide_img {
  width: 100%;
  height: auto;
}


.title {
  font-family: PingFangSC-Semibold;
  font-size: 1.3rem;
  color: #000000;
  text-align: center;
}

.sub_title {
  font-family: PingFangSC-Regular;
  font-size: 0.875rem;
  color: #999999;
  text-align: center;
  width: 80%;
  margin-top: 1rem;
}

.close_button {
  width: calc(100% - 1.5rem);
  height: 2.815rem;
  background-image: linear-gradient(-45deg, #FF4948 0%, #F98A50 100%);
  border-radius: 0.5rem;
  line-height: 2.815rem;
  font-size: 1rem;
  color: #FFFFFF;
  text-align: center;
  margin-bottom: 1rem;
}

.help_layout {
  display: flex;
  margin-bottom: 2rem;
  align-content: center;
  align-items: center;
}

.help {
  height: 1.25rem;
  font-family: PingFangSC-Regular;
  font-size: 0.9rem;
  line-height: 1.25rem;
  color: #999999;
  letter-spacing: 0;
  text-align: center;
}

.help_arch {
  width: 0.8rem;
  height: 0.8rem;
  margin-left: 0.5rem;
  /*margin-bottom: 0.1rem;*/
}


</style>



// WEBPACK FOOTER //
// src/components/setting/CloseAiPage.vue